import { QueryEntity } from '@datorama/akita';
import { Injectable } from '@angular/core';
import { IKonnectLocation } from 'typings/doenkids/doenkids';
import { KonnectLocationStore, IKonnectLocationState } from './konnect-location.store';

@Injectable({ providedIn: 'root' })
export class KonnectLocationQuery extends QueryEntity<IKonnectLocationState, IKonnectLocation> {
  constructor(protected store: KonnectLocationStore) {
    super(store);
  }
}
